import { FaCheck } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

import Button from '../../components/Button';
import { ButtonsContainer, Container } from './styles';

const SuccessPurchase = () => {
  const history = useHistory();
  const urlParams = new URLSearchParams(window.location.search);
  const projectId = urlParams.get('projectId');

  function handleHomeButtonClick() {
    history.push('/projects');
  }

  function handleProjectButtonClick() {
    history.push(`/projects/${projectId}`);
  }

  return (
    <Container>
      <FaCheck size={56} color="var(--success)" />
      <h1>Compra efetuada com sucesso</h1>
      <p>
        Oba! Sua compra foi finalizada com sucesso e agora você já pode cortar o
        projeto comprado utilizando o programa Due Studio. Obrigado
      </p>
      <ButtonsContainer>
        {projectId && (
          <Button
            text="Ir para página do projeto"
            onClick={handleProjectButtonClick}
          />
        )}
        <Button
          text="Voltar para página explorar"
          onClick={handleHomeButtonClick}
        />
      </ButtonsContainer>
    </Container>
  );
};

export default SuccessPurchase;
